module.exports = __webpack_public_path__ + "img/orange-lily.d1f49cf7.webp";